const challenges = [
    { id: 1, theme: "Lumière et Ombre", submissions: [{ title: "Clair-Obscur", artist: "Alice", image: "challenge1.jpg" }] },
  ];
  
  export default challenges;
  